import {getEndOfDayTimestamp, getStartOfDayTimestamp} from "../../../Apis/functions";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

export const EXPORT_FILE_TYPE_MODEL ={
    PILGRIMS_ACCESS_REPORT:"pilgrims_access_report",
    PILGRIMS_MEAL_TIME_REPORT:"pilgrims_meal_time_report"
}

export const EXPORT_FORMAT_MODEL ={
    EXCEL:"excel",
    PDF:"pdf"
}


export const MODULE_EXPORT_DATA_MODEL ={
    model: null,
    exportFormat: null,
    attendanceStartDate: null,
    attendanceEndDate: null,
    toRegister: function (exportModuleDataOption, isExcel){
        return {
            model: exportModuleDataOption,
            attendanceStartDate: getStartOfDayTimestamp(this.attendanceStartDate),
            attendanceEndDate: getEndOfDayTimestamp(this.attendanceEndDate),
            exportFormat: isExcel ? EXPORT_FORMAT_MODEL.EXCEL : EXPORT_FORMAT_MODEL.PDF
        }
    },
    isValid: function (){
        return this.attendanceStartDate !== null && this.attendanceEndDate !== null
            && new Date(this.attendanceEndDate) >= new Date(this.attendanceStartDate);
    },
    isValidRange: function (){
        if(!this.attendanceStartDate || !this.attendanceEndDate) return true;

        return new Date(this.attendanceEndDate) >= new Date(this.attendanceStartDate);
    },
    clear: function (){
        return {
            ...this,
            model: null,
            attendanceStartDate: null,
            attendanceEndDate: null
        }
    }
}
